export default "__VITE_ASSET__a96da43d__"